import React, { useState, useEffect } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn';
import { useMsal } from '@azure/msal-react';
import { useHistory } from 'react-router-dom';
import PageSubTitle from '../../component/Common/PageSubTitle';
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import { useLooksUpData } from '../../utils/getLookupTableData';
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'

const HealthCareServiceQuality = () => {
    const [isLoading, setIsLoading] = useState(false)
    const gridStyle = { minHeight: 622, width: '100%' };
    const [gridRef, setGridRef] = useState(null as any)
    const history = useHistory()

    const ReportHeaders: any[] = [
        {
            name: 'measure_name',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Measure
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'description',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Description
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'metric',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Metric
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'source',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Source
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'effective_from_date',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Effective From Date
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'trend',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Trend
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
    ]

    const reportResponseList = [
        {
            key: 1,
            measure_name: 'Timely Resolution Rate',
            description: 'Data received for Grievances, Appeals and Fair Hearings from Plan',
            metric: '95% of grievances and appeals are resolved within required timeframes.',
            source: 'Grievance Log, Appeals Log and State Fair Hearings Log',
            effective_from_date: '1/1/2023',
            trend: ''
        },
        {
            key: 2,
            measure_name: 'Appeals - Rate per 1000',
            description: 'Data received for Grievances, Appeals and Fair Hearings from Plan',
            metric: 'No more than 3 grievances per 1,000 members per quarter',
            source: 'Grievance Log, Appeals Log and State Fair Hearings Log',
            effective_from_date: '1/1/2023',
            trend: ''
        },
        {
            key: 3,
            measure_name: 'Calls Answered Timeline',
            description: 'Call Center specific data for various services for both Members and Providers',
            metric: '80% of calls answered within 30 seconds',
            source: 'Call Center Report',
            effective_from_date: '2/1/2025',
            trend: ''
        },
        {
            key: 4,
            measure_name: 'Call hold time',
            description: 'Call Center specific data for various services for both Members and Providers',
            metric: '90% of calls not on hold more than 5 minutes',
            source: 'Call Center Report',
            effective_from_date: '2/1/2025',
            trend: ''
        },
        {
            key: 6,
            measure_name: 'Appointment Availability',
            description: 'Timely appointments availability with PCPs',
            metric: '90% within 24 hours',
            source: 'Plans Provider Network and Provider Network changes',
            effective_from_date: '1/1/2023',
            trend: ''
        },
        {
            key: 8,
            measure_name: 'Claims Timely Payment Rate',
            description: 'Timely payments to providers',
            metric: '100% within a week of adjudication',
            source: 'Monthly Medical Claims Report, Pharmacy Claims Report',
            effective_from_date: '1/1/2023',
            trend: ''
        },

    ];

    const filterValue =
        [
            { name: 'measure_name', operator: 'contains', type: 'string', value: '' },
            { name: 'description', operator: 'contains', type: 'string', value: '' },
            { name: 'metric', operator: 'contains', type: 'string', value: '' },
            { name: 'source', operator: 'contains', type: 'string', value: '' },
            { name: 'effective_from_date', operator: 'contains', type: 'string', value: '' }
        ]

    const handleRowClick = (data: any) => {
        // if (!checkAccess('report_inventory_listpage', 'NOAC')) {
        // history.push({
        //     pathname: '/',
        //     state: { recordData: data }
        // });
        // }
    }

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="Operations Quality Scores" />
                </div>
            </div>

            <div className="form-layout">
                {isLoading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading.....</p>
                    </div>
                ) :
                    <>
                        <ReactDataGrid
                            licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                            idProperty="key"
                            style={gridStyle}
                            pagination
                            virtualized
                            columns={ReportHeaders}
                            dataSource={reportResponseList}
                            sortable={true}
                            // onFilterValueChange={handleFilterChangeGrid}
                            defaultLimit={10}
                            defaultFilterValue={filterValue}
                            rowHeight={50}
                            onRowClick={({ data }) => handleRowClick(data)}
                            className="pointer-cursor-row"
                            // loading={isFilesGridLoading}
                            enableColumnAutosize={true}
                            handle={setGridRef}
                            pageSizes={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                        />

                    </>
                }
            </div>

            <Footer />
        </>
    );
};

export default HealthCareServiceQuality;